import React, { useMemo } from 'react'
import { useIntl } from 'react-intl'
import { Modal, Typography } from 'antd'
import { getCacheGuideSteps } from 'utils/appUpdate'

// Panduan hapus cache browser untuk user yang masih tersangkut setelah beberapa kali "Coba Lagi".
// Langkah dipilih sesuai perangkat (Windows, Mac, Safari, HP, atau app desktop).
const ClearCacheGuideModal = ({ open, onRetry, onClose }) => {
  const { formatMessage } = useIntl()
  const steps = useMemo(() => getCacheGuideSteps(), [])

  return (
    <Modal
      open={open}
      title={formatMessage({ id: 'notification.cache_guide_title' })}
      okText={formatMessage({ id: 'notification.cache_guide_reload' })}
      cancelText={formatMessage({ id: 'button.close' })}
      onOk={onRetry}
      onCancel={onClose}
    >
      <Typography.Paragraph>
        {formatMessage({ id: 'notification.cache_guide_intro' })}
      </Typography.Paragraph>
      <ol>
        {steps.map((step) => (
          <li key={step}>{formatMessage({ id: `notification.cache_guide_step_${step}` })}</li>
        ))}
      </ol>
      <Typography.Paragraph type="secondary">
        {formatMessage({ id: 'notification.cache_guide_footer' })}
      </Typography.Paragraph>
    </Modal>
  )
}

export default ClearCacheGuideModal
